import f from "classnames";
import w from "embla-carousel-react";
import * as t from "react";
import { isEditMode as C, root as M, backgroundImage as P, backgroundImageOverlay as j, backgroundVideo as D, backgroundVideoOverlay as F, header as L, title as O, carouselRoot as U, carouselViewport as X, carouselContainer as q, carouselSlide as g, bottom as z, buttonLink as A, buttonIcon as B } from "./CardProduct.css.js";
import { jsxs as c, Fragment as b, jsx as e } from "react/jsx-runtime";
import { Icon as G } from "../icon/Icon.js";
const v = 0;
function Y(N) {
  const [k, p] = t.useState(v), [E, r] = w({
    align: "start",
    containScroll: "",
    slidesToScroll: "auto",
    startIndex: v
  }), {
    element: i,
    children: I,
    className: S,
    attributes: x,
    backgroundImageElement: y,
    isEditMode: V
  } = N;
  t.useEffect(() => {
    const l = () => {
      r != null && r.selectedScrollSnap && p(r.selectedScrollSnap());
    };
    return r == null || r.on("scroll", l), () => {
      r == null || r.off("scroll", l);
    };
  }, [r]);
  const {
    customAttributes: R,
    gridProps: a,
    background: u,
    backgroundVideo: o,
    title: $,
    mobile_hide: T,
    desktop_hide: _,
    buttonText: n,
    url: m
  } = i, h = y || i.backgroundImage, s = t.useRef(null);
  return t.useEffect(() => {
    s.current && o && s.current.load();
  }, [s.current, o]), /* @__PURE__ */ c("div", {
    ...R,
    className: f(S, {
      "mobile:hidden": T,
      "desktop:hidden": _,
      [C]: V
    }, M),
    style: {
      "--grid-x": a.x + 1,
      "--grid-y": a.y + 1,
      "--grid-w": a.w,
      "--grid-h": a.h,
      ...u && {
        background: u
      }
    },
    ...x,
    children: [t.isValidElement(h) && /* @__PURE__ */ c(b, {
      children: [/* @__PURE__ */ e("div", {
        contentEditable: !1,
        className: P,
        children: h
      }), /* @__PURE__ */ e("div", {
        className: j
      })]
    }), o && /* @__PURE__ */ c(b, {
      children: [/* @__PURE__ */ e("video", {
        ref: s,
        contentEditable: !1,
        className: f(D),
        autoPlay: !0,
        muted: !0,
        loop: !0,
        playsInline: !0,
        children: /* @__PURE__ */ e("source", {
          src: o
        })
      }), /* @__PURE__ */ e("div", {
        className: F
      })]
    }), /* @__PURE__ */ e("div", {
      className: L,
      children: /* @__PURE__ */ e("h1", {
        className: O,
        children: $
      })
    }), /* @__PURE__ */ e("div", {
      className: U,
      children: /* @__PURE__ */ e("div", {
        ref: E,
        className: X,
        children: /* @__PURE__ */ e("div", {
          className: q,
          children: t.Children.map(I, (l, d) => t.isValidElement(l) ? /* @__PURE__ */ e("div", {
            className: g,
            children: t.cloneElement(l, {
              isActive: d === k
            })
          }, `embla-carousel-${d + 1}`) : /* @__PURE__ */ e("div", {
            className: g,
            children: l
          }, `embla-carousel-${d + 1}`))
        })
      })
    }), n || m ? /* @__PURE__ */ e("div", {
      className: z,
      children: /* @__PURE__ */ c("a", {
        className: A,
        href: m,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [n ? /* @__PURE__ */ e("span", {
          children: n
        }) : null, /* @__PURE__ */ e(G, {
          className: B,
          type: "bx",
          name: "right-arrow-alt"
        })]
      })
    }) : null]
  });
}
export {
  Y as CardProduct
};
